export default __webpack_public_path__ + "static/media/woman-1.3dc5f53e.png";